module.exports = __webpack_public_path__ + "img/manage4.ebb2a08e.png";